import { Component, inject, OnInit } from '@angular/core';
import { LogService } from './infrastructure/logging/log.service';
import { HeaderComponent } from '../app/components/header/header.component';
import { GoogleTagManagerService } from 'angular-google-tag-manager';
import { NavigationEnd, Router } from '@angular/router';
import { filter } from 'rxjs';
import { AuthService } from './infrastructure/login/auth.service';

@Component({
  selector: 'app-root',
  standalone: false,
  //imports: [HeaderComponent],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss'
})
export class AppComponent implements OnInit {
  title = 'Gitt Toolset';
 logger = inject(LogService);
 gtmService = inject(GoogleTagManagerService);
 authService = inject(AuthService);
 
router = inject(Router);


 constructor() {
 this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        const url = event.urlAfterRedirects;

        // General navigation tracking for all routes via GTM
        const pageViewTag = {
          event: 'page_view',
          pageName: url,
          send_to: 'AW-1009494530/zcjPCP-Vr-AaEILUruED'
        };
        this.gtmService.pushTag(pageViewTag);
        console.log(`GTM page view pushed for ${url}`); // For debugging

        // Google Ads conversion tracking for specific routes
        if (url === '/success') {  // completed a buy
          const buyConversionTag = {
            event: 'success',
            email: this.authService.user.email ?? "(no email)",
            send_to: 'AW-1009494530/dIoWCMDFqt8aEILUruED', // Replace with your Buy conversion ID/label
          };
          this.gtmService.pushTag(buyConversionTag);
          console.log('Google Ads conversion pushed for /buy');
        } else if (url === '/trialLicense') {
          const tryConversionTag = {
            event: 'trialLicense',
            email: this.authService.user.email ?? "(no email)",
            send_to: 'AW-1009494530/C0xQCMbEpN8aEILUruED', // Replace with your Try conversion ID/label
          };
          this.gtmService.pushTag(tryConversionTag);
          console.log('Google Ads conversion pushed for /trialLicense');
        } 
      });
 }
 ngOnInit(): void {
   
 }


}
